import * as yup from 'yup';
export const authTableSchema = yup.object().shape({
  auth_code: yup.string().required('認証コードを入力してください'),
});
